import RequestService, { getQueryURL } from '../requestService';
import { client } from '../../client';
import { MessageRequiredAnswer } from '../../../models/messageRequiredAnswer';
import { Flytstatus } from '../../../models';

export default class FlytstatusService extends RequestService<Flytstatus, 'flytstatus'> {
    importFromXML = async (fileContent: Blob, filNavn: string) => {
        try {
            const buffer = await fileContent.arrayBuffer();
            const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/import`, { filNavn }), buffer);
            return { success: true, msg: res.message };
        } catch (err) {
            return { success: false, msg: (err as Error).message };
        }
    };
    eksportTilXml = async (id?: number) => await client.getFile(`${this.serviceName}/${id ? encodeURIComponent(id) + '/' : ''}xml-eksport`, 'GET');
}
